export default __webpack_public_path__ + "static/char-s-41-ko-99826320960ee7124a98fbe93d1695f9.webp";